import { connect } from "react-redux";
import CMS from "./CMS";
import { mapStateToProps, mapDispatchToProps } from "./CMS.state";

export default connect(mapStateToProps, mapDispatchToProps)(CMS);
